import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import HRGridTab from './HRGridTab';
import HierNode from './HierNode';

// =============================================================
// First 3 HR Report sub-tabs — exact Excel grid (Employee × Date)
// =============================================================

// 1. Staff Advance Work Index
export const StaffAdvanceWorkIndexTab = () => (
  <HRGridTab
    tab="staff_advance"
    title="STAFF ADVANCE WORK INDEX"
    titleBg="#f59e0b"
    titleFg="#1c1917"
    useColorPicker={true}
  />
);

// 2. Daily Work Report Index
export const DailyWorkReportIndexTab = () => (
  <HRGridTab
    tab="daily_work_report"
    title="DAILY WORK REPORT INDEX"
    titleBg="#10b981"
    titleFg="#ffffff"
    useAutoStatus={true}
  />
);

// 3. Daily Schedule Report Index
export const DailyScheduleReportIndexTab = () => (
  <HRGridTab
    tab="daily_schedule_report"
    title="DAILY SCHEDULE REPORT INDEX"
    titleBg="#ea580c"
    titleFg="#ffffff"
    useAutoStatus={true}
  />
);

// 4. Staff Report Index — same Excel grid
export const StaffReportIndexTab = () => (
  <HRGridTab
    tab="staff_report_index"
    title="STAFF REPORT INDEX"
    titleBg="#7c3aed"
    titleFg="#ffffff"
  />
);

// 5. Daily Work
export const DailyWorkTab = () => (
  <HRGridTab
    tab="daily_work"
    title="DAILY WORK"
    titleBg="#16a34a"
    titleFg="#ffffff"
  />
);

// 6. Daily Schedule
export const DailyScheduleTab = () => (
  <HRGridTab
    tab="daily_schedule"
    title="DAILY SCHEDULE"
    titleBg="#92400e"
    titleFg="#ffffff"
  />
);

// =============================================================
// 13. Company Hierarchy
// =============================================================
export const CompanyHierarchyTab = () => {
  const TREE = {
    name: 'CMD — Mr. Dinesh B. Kurkute', role: 'Chairman & Managing Director', color: '#1e3a8a',
    children: [{
      name: 'Mr. Amitkumar Ponde', role: 'CEO / Director', color: '#7c3aed',
      children: [
        { name: 'Sahil Karale', role: 'HR Head', color: '#0891b2', children: [{ name: 'Nayna Palherkar', role: 'HR Executive', color: '#06b6d4' }] },
        { name: 'Chaitrali Ingale', role: 'Marketing Head', color: '#16a34a', children: [
          { name: 'Komal Markad', role: 'DM Operator', color: '#22c55e' },
          { name: 'Tushar Dhamal', role: 'CP Tracker', color: '#22c55e' },
        ] },
        { name: 'Mr. Mahadev Ranpise', role: 'Finance Head', color: '#dc2626' },
        { name: 'Operations Head', role: 'Operations', color: '#ea580c' },
        { name: 'Legal Head', role: 'Legal', color: '#9333ea' },
        { name: 'IT Head', role: 'IT', color: '#0d9488' },
      ],
    }],
  };

  return (
    <div data-testid="company-hierarchy-tab">
      <div className="bg-indigo-900 text-white px-3 py-2 rounded-t font-bold text-sm">COMPANY HIERARCHY</div>
      <Card className="rounded-t-none">
        <CardContent className="p-6 overflow-auto">
          <div className="min-w-max"><HierNode node={TREE} /></div>
        </CardContent>
      </Card>
    </div>
  );
};

// =============================================================
// 14. Project Hierarchy
// =============================================================
export const ProjectHierarchyTab = () => {
  const PROJECTS = [
    { name: 'Sai Plaza (Rajgurunagar)', head: 'Sahil Karale', stage: 'Finishing', color: '#16a34a' },
    { name: 'Office Dream Riviera', head: 'Sahil Karale', stage: 'Possession', color: '#0891b2' },
    { name: 'Bramha Heights', head: 'Sahil Karale', stage: 'Painting', color: '#9333ea' },
    { name: 'Godavari Heights', head: 'Sahil Karale', stage: 'Brickwork', color: '#dc2626' },
    { name: 'Kaveri Heights', head: 'Sahil Karale', stage: 'Structure', color: '#ea580c' },
    { name: 'Krushna Heights', head: 'Sahil Karale', stage: 'Plinth', color: '#0d9488' },
    { name: 'Dreams Kokan City', head: 'Sahil Karale', stage: 'Approvals', color: '#7c3aed' },
    { name: 'Dreams Nagpur City', head: 'Sahil Karale', stage: 'Land Acquisition', color: '#1e40af' },
  ];

  return (
    <div data-testid="project-hierarchy-tab">
      <div className="bg-emerald-900 text-white px-3 py-2 rounded-t font-bold text-sm">PROJECT HIERARCHY</div>
      <Card className="rounded-t-none">
        <CardContent className="p-6">
          <div className="flex flex-col items-center">
            <div className="px-6 py-3 rounded-lg shadow-lg bg-gradient-to-br from-blue-700 to-blue-500 text-white text-center">
              <div className="font-bold">DBK GROUP OF INDUSTRIES</div>
              <div className="text-[11px] opacity-90">All Projects</div>
            </div>
            <div className="w-0.5 h-6 bg-stone-400" />
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 pt-4 border-t-2 border-stone-300 w-full">
              {PROJECTS.map((p, i) => (
                <div key={i} className="px-3 py-2 rounded-lg shadow text-white text-center" style={{ backgroundColor: p.color }}>
                  <div className="font-bold text-xs">{p.name}</div>
                  <div className="text-[10px] opacity-90">Head: {p.head}</div>
                  <div className="text-[10px] opacity-90 mt-1 bg-white/20 rounded px-1.5 py-0.5">Stage: {p.stage}</div>
                </div>
              ))}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
